import { Box, Checkbox, Collapse, FormControlLabel } from '@mui/material';
import React from 'react';
import { Hoster, SubscriptionStatus } from '../../../interfaces/Hoster';

export interface BaseModuleProps {
  name: keyof SubscriptionStatus;
  label: string;
  onChange: (key: string, value: boolean) => void;
  children?: React.ReactNode;
  hoster: Partial<Hoster>;
  setHoster: React.Dispatch<React.SetStateAction<Partial<Hoster>>>;
}

export default function BaseModule({ name, hoster, onChange, label, children }: BaseModuleProps) {
  const { subscriptionStatus } = hoster;
  if (!subscriptionStatus) return null;

  return (
    <Box
      key={name}
      sx={{
        display: 'flex',
        flexDirection: 'column',
      }}
    >
      <FormControlLabel
        key={name}
        control={
          <Checkbox
            checked={!!subscriptionStatus[name] || false}
            onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
              onChange(name, e.target.checked);
            }}
            sx={{ p: 0.5, mr: 1 }}
          />
        }
        label={label}
        sx={{
          m: 0,
          p: 0,
          minHeight: 0,
          lineHeight: 1,
        }}
      />
      <Collapse in={!!subscriptionStatus[name]} timeout="auto" unmountOnExit>
        {children}
      </Collapse>
    </Box>
  );
}
